import type { PreAuthStatus } from '../services/preAuthorizationService';

export const APPOINTMENT_STATUS_BADGE: Record<string, string> = {
  SCHEDULED: 'custom-badge status-blue',
  CONFIRMED: 'custom-badge status-green',
  WAITING: 'custom-badge status-orange',
  IN_CONSULTATION: 'custom-badge status-purple',
  COMPLETED: 'custom-badge status-green',
  CANCELLED: 'custom-badge status-red',
  NO_SHOW: 'custom-badge status-grey',
};

export const INVOICE_STATUS_LABELS: Record<string, string> = {
  draft: 'Borrador',
  paid: 'Pagado',
  cancelled: 'Anulado',
};

export const INVOICE_STATUS_CLASSES: Record<string, string> = {
  draft: 'warning',
  paid: 'success',
  cancelled: 'danger',
};

export const PRE_AUTH_STATUS_BADGE: Record<PreAuthStatus, string> = {
  pending: 'badge bg-warning text-dark',
  approved: 'badge bg-success',
  rejected: 'badge bg-danger',
  expired: 'badge bg-secondary',
  cancelled: 'badge bg-secondary',
  used: 'badge bg-info',
};

export const PRE_AUTH_STATUS_LABELS: Record<PreAuthStatus, string> = {
  pending: 'Pendiente',
  approved: 'Aprobada',
  rejected: 'Rechazada',
  expired: 'Expirada',
  cancelled: 'Cancelada',
  used: 'Usada',
};
